import GameManager from '../../../core/GameManager';
import { ScenarioSceneType, ScenarioEndType } from '../../../misc/BleedingControlScenario';
import MainPracticeScenario from './MainPracticeScenario/MainPracticeScenario';
import { constants } from '../../../misc/helpers';
import {getPracticeCScenario} from './practiceStartText';

export default class PracticeScenarioC extends MainPracticeScenario {
	constructor(gameManager: GameManager, scenarioName: string) {
		var locations = [
			{
				type: constants.placementType.wrong,
				position: 19,
			},
			{
				type: constants.placementType.close,
				position: 36,
			},
			{
				type: constants.placementType.correct1,
				position: 60,
			},
		];

		var locations2 = [
			{
				type: constants.placementType.wrong,
				position: 19,
			},
			{
				type: constants.placementType.close,
				position: 36,
			},
			{
				type: constants.placementType.correct1,
				position: 78,
			},
		];

		var correctT1 = 2;
		var correctT2 = 3;
		var wrongT1 = 0;
		var closeT1 = 1;

		super(gameManager, scenarioName, ScenarioSceneType.scenarioC, ScenarioEndType.end, [], true, 0.23, 0.40, locations, locations2, correctT1, correctT2, wrongT1, closeT1, false, false, true, false, 'Gunshot Wound - Practice Scenario', getPracticeCScenario() );
	}

	public get totalNumberOfQuestions(): number {
		return 15;
	}

	public soundFolderAndPath(section: string, part: string): string {
		return '08-Scenario C/BC-Scenario-C-'  + section + '-Part-' + part;
	}
}